<template>
  <div class="app-container">
    <el-button type="primary" @click="handleAddRole"> 增加角色 </el-button>

    <el-button type="danger" @click="syncRoute"> 同步路由 </el-button>

    <el-alert
      title="手動添加路由後須要按下同步路由，將路由資料同步至資料庫後，再進行角色的權限設定。設定後持有該角色的帳號必須重新整理網頁。"
      type="success"
      :closable="false"
    >
    </el-alert>

    <el-table v-loading="loading" :data="rolesList" style="width: 100%; margin-top: 30px" border>
      <el-table-column align="center" label="Role Key" width="220">
        <template slot-scope="scope">
          {{ scope.row.key }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="Role Name" width="220">
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>
      <el-table-column align="header-center" label="Description">
        <template slot-scope="scope">
          {{ scope.row.description }}
        </template>
      </el-table-column>

      <el-table-column align="header-center" label="Member" width="220">
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.memberContent" placement="bottom" effect="light">
            <div slot="content" v-html="scope.row.memberContent" />
            <el-tag type="success" effect="dark" style="margin-left: 5px">
              {{ scope.row.memberCount }}
            </el-tag>
          </el-tooltip>
          <div v-else>-</div>
        </template>
      </el-table-column>

      <el-table-column align="center" label="Operations">
        <template slot-scope="scope">
          <el-button type="primary" size="small" @click="handleEdit(scope)"> 編輯權限 </el-button>
          <el-button type="danger" size="small" @click="handleDelete(scope)"> 刪除 </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      v-loading="loading"
      :visible.sync="dialogVisible"
      :title="dialogType === 'edit' ? 'Edit Role' : 'New Role'"
    >
      <el-form :model="role" label-width="80px" label-position="left">
        <el-form-item label="Key">
          <el-input v-model="role.key" placeholder="Role key" :read-only="dialogType === 'edit'" />
        </el-form-item>

        <el-form-item label="Name">
          <el-input v-model="role.name" placeholder="Role Name" />
        </el-form-item>
        <el-form-item label="Desc">
          <el-input
            v-model="role.description"
            :autosize="{ minRows: 2, maxRows: 4 }"
            type="textarea"
            placeholder="Role Description"
          />
        </el-form-item>
        <el-form-item label="Menus">
          <el-tree
            ref="tree"
            :check-strictly="checkStrictly"
            :data="routesData"
            :props="defaultProps"
            show-checkbox
            node-key="path"
            class="permission-tree"
            @check="onCheck"
          />
        </el-form-item>
      </el-form>
      <div style="text-align: right">
        <el-button type="primary" @click="confirmRole"> 確定 </el-button>
        <el-button type="danger" @click="dialogVisible = false"> 取消 </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/*
有新的路由增加 可能因為非同步的關西，必須手動再資料庫先增加 再同步路由 才會出現在畫面上面。
雖然 asyncRoutes看起來是去抓路由表全部路由，但實際上不會有裡面出現內容 奇怪的事@@
*/
import path from 'path'
import { deepClone } from '@/utils'
import { getRoles, saveRole, deleteRole, syncRoute, getRoleMembers } from '@/api/role'

import { asyncRoutes, constantRoutes } from '@/router'
import { filterAsyncRoutes } from '@/store/modules/permission'
import { MessageBox, Message } from 'element-ui'

const defaultRole = {
  key: '',
  name: '',
  description: '',
  routes: [],
}

const defaultMenus = [
  {
    hidden: false,
    name: 'HomeIndex',
    path: '/',
    redirect: '/dashboard',
    children: [
      {
        meta: { title: 'dashboard', icon: 'dashboard', affix: true },
        name: 'Dashboard',
        path: '/dashboard',
      },
    ],
  },
]
export default {
  data() {
    return {
      serviceRoutes: [],
      loading: false,
      role: Object.assign({}, defaultRole),
      routes: [],
      rolesList: [],
      dialogVisible: false,
      dialogType: 'new',
      checkStrictly: false,
      defaultProps: {
        children: 'children',
        label: 'title',
      },
    }
  },
  computed: {
    routesData() {
      return this.routes
    },
  },
  async created() {
    // Mock: get all routes and roles list from server
    this.loading = true
    await this.getRoutes()

    await this.getRoles()
    this.loading = false
  },
  methods: {
    getMembers({ $index, row }) {
      const find = this.rolesList[$index]

      getRoleMembers(row.key).then(response => {
        console.log(response)
        find.memberContent = ''
        find.memberCount = response.data.length
        find.memberContent += "<div style='height: 200px;overflow-y:scroll;'>"
        find.memberContent += `<span style='color:blue;'>共計${response.data.length}個成員。</span><br/>`
        if (response.data.length > 0) {
          response.data.forEach(f => {
            const info = `${f.account} ${f.name}<br/>`
            find.memberContent += info
          })
          find.memberContent += '</div>'
        }
      })
    },
    onCheck(currentObj, treeStatus) {
      // this.checkedKeys = treeStatus.checkedKeys;
    },
    async syncRoute() {
      const vm = this
      this.$confirm('【將會同步 Vue Route 所有Route至伺服器】', 'sync route', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'success',
      })
        .then(async () => {
          vm.loading = true
          let routesSource = deepClone([...asyncRoutes])

          routesSource = vm.syncDescription(routesSource)
          const res = await syncRoute(routesSource)
          this.loading = false

          this.$notify({
            title: 'Success',
            dangerouslyUseHTMLString: true,
            message: `<div>route sync successful!</div>`,
            type: 'success',
          })
        })
        .catch(err => {
          console.error(err)
        })
    },
    async getRoutes() {
      // 取自前端路由表所有路由
      let c1 = constantRoutes
      let c2 = asyncRoutes
      const routesSource = deepClone([...constantRoutes, ...asyncRoutes])
      this.serviceRoutes = routesSource

      const routes = this.generateRoutes(routesSource)
      debugger
      // this.routes = this.i18n(routes);
      this.routes = routes
      this.routes.forEach(f => {
        if (f.path == '/dashboard') {
          f.disabled = true
        }
      })
    },
    async getRoles() {
      // 取得角色以及所有持有的路由
      const vm = this
      vm.loading = true
      const res = await getRoles()
      vm.loading = false
      const roles = res.data
      // 使用stringify序列化及反序列化複製serviceRoutes(所有前端路由表) filterAsyncRoutes 因為會為對物件傳址而影響children數量
      // 放置迴圈裏面每次都重新產生新的路由表物件，否則選單會有未勾選的項目
      roles.forEach(f => {
        const deServiceRoutes = JSON.parse(JSON.stringify(vm.serviceRoutes))
        const filterRoute = filterAsyncRoutes(deServiceRoutes, f.routes)
        f.routes = [...defaultMenus, ...filterRoute]
      })
      roles.forEach((f, index) => {
        f.memberContent = ''
        f.memberCount = 0
      })
      this.rolesList = roles
      this.rolesList.forEach((f, index) => {
        vm.getMembers({ $index: index, row: f })
      })
    },
    syncDescription(routes) {
      const app = routes.map(route => {
        if (typeof route.meta === 'undefined') {
          return route
        }
        route.description = route.meta.title
        if (route.children) {
          route.children = this.syncDescription(route.children)
        }
        return route
      })
      return app
    },
    // i18n(routes) {
    //   const app = routes.map((route) => {
    //     route.title = i18n.t(`route.${route.title}`);
    //     if (route.children) {
    //       route.children = this.i18n(route.children);
    //     }
    //     return route;
    //   });
    //   return app;
    // },
    // sync_i18n(routes) {
    //   const app = routes.map((route) => {
    //     if (typeof route.meta === "undefined") {
    //       return route;
    //     }
    //     route.description = i18n.t(`route.${route.meta.title}`);
    //     if (route.children) {
    //       route.children = this.sync_i18n(route.children);
    //     }
    //     return route;
    //   });
    //   return app;
    // },
    // Reshape the routes structure so that it looks the same as the sidebar
    generateRoutes(routes, basePath = '/') {
      const res = []
      for (let route of routes) {
        // skip some route
        if (typeof route.name === 'undefined') {
          continue
        }
        // if (route.hidden && !route.display) {
        //   continue;
        // }

        const onlyOneShowingChild = this.onlyOneShowingChild(route.children, route)

        if (route.children && onlyOneShowingChild && !route.alwaysShow) {
          route = onlyOneShowingChild
        }

        const data = {
          path: path.resolve(basePath, route.path),
          title: route.meta && route.meta.title,
        }

        // recursive child routes
        if (route.children) {
          data.children = this.generateRoutes(route.children, data.path)
        }
        res.push(data)
      }
      return res
    },
    generateArr(routes) {
      let data = []
      routes.forEach(route => {
        data.push(route)
        if (route.children) {
          const temp = this.generateArr(route.children)
          if (temp.length > 0) {
            data = [...data, ...temp]
          }
        }
      })
      return data
    },
    handleAddRole() {
      this.role = Object.assign({}, defaultRole)
      this.role.routes = defaultMenus
      if (this.$refs.tree) {
        //        this.$refs.tree.setCheckedNodes([]);
        this.$refs.tree.setCheckedNodes(this.generateArr(defaultMenus))
      }
      this.dialogType = 'new'
      this.dialogVisible = true
    },
    handleEdit(scope) {
      debugger
      this.dialogType = 'edit'
      this.dialogVisible = true
      this.checkStrictly = true
      this.role = deepClone(scope.row)
      this.$nextTick(() => {
        const routes = this.generateRoutes(this.role.routes)
        this.$refs.tree.setCheckedNodes(this.generateArr(routes))
        // set checked state of a node not affects its father and child nodes
        this.checkStrictly = false
      })
    },
    handleDelete({ $index, row }) {
      this.$confirm('Confirm to remove the role?', 'Warning', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning',
      })
        .then(async () => {
          this.loading = true

          await deleteRole(row.key)
          this.loading = false

          this.rolesList.splice($index, 1)
          this.$message({
            type: 'success',
            message: 'Delete succed!',
          })
        })
        .catch(err => {
          console.error(err)
        })
    },
    generateTree(routes, basePath = '/', checkedKeys) {
      const res = []

      for (const route of routes) {
        const routePath = path.resolve(basePath, route.path)
        // recursive child routes
        if (route.children) {
          route.children = this.generateTree(route.children, routePath, checkedKeys)
        }

        if (checkedKeys.includes(routePath) || (route.children && route.children.length >= 1)) {
          res.push(route)
        }
      }
      return res
    },
    async confirmRole() {
      if (!confirm(`確定儲存角色${this.role.key}?`)) {
        return
      }

      const isEdit = this.dialogType === 'edit'
      if (!this.role.key) {
        Message({
          message: `未輸入角色key`,
          type: 'error',
          duration: 5 * 1000,
        })
        return false
      }

      if (!this.role.description) {
        Message({
          message: `未輸入角色描述`,
          type: 'error',
          duration: 5 * 1000,
        })
        return false
      }
      // getCheckedKeys 使用元件內建含式取得已經選取的key
      const checkedKeys = this.$refs.tree.getCheckedKeys()
      this.role.routes = this.generateTree(deepClone(this.serviceRoutes), '/', checkedKeys)
      if (isEdit) {
        this.loading = true
        await saveRole(this.role)
        this.loading = false

        for (let index = 0; index < this.rolesList.length; index++) {
          if (this.rolesList[index].key === this.role.key) {
            this.rolesList.splice(index, 1, Object.assign({}, this.role))
            break
          }
        }
      } else {
        if (this.rolesList.includes(this.role.key)) {
          Message({
            message: `已有相同角色名稱(key):${this.role.key}`,
            type: 'error',
            duration: 5 * 1000,
          })
          return false
        }
        this.loading = true
        const { data } = await saveRole(this.role)
        this.loading = false

        this.role.key = data
        this.rolesList.push(this.role)
      }

      const { description, key, name } = this.role
      this.dialogVisible = false
      this.$notify({
        title: 'Success',
        dangerouslyUseHTMLString: true,
        message: `
            <div>Role Key: ${key}</div>
            <div>Role Name: ${name}</div>
            <div>Description: ${description}</div>
          `,
        type: 'success',
      })
    },
    // reference: src/view/layout/components/Sidebar/SidebarItem.vue
    //只有一個子目錄會直接當作主目錄
    onlyOneShowingChild(children = [], parent) {
      let onlyOneChild = null
      // const showingChildren = children.filter(item => !item.hidden);
      const showingChildren = children.filter(item => typeof item.name !== 'undefined')

      // When there is only one child route, the child route is displayed by default
      if (showingChildren.length === 1) {
        onlyOneChild = showingChildren[0]
        onlyOneChild.path = path.resolve(parent.path, onlyOneChild.path)
        return onlyOneChild
      }

      // Show parent if there are no child route to display
      if (showingChildren.length === 0) {
        onlyOneChild = { ...parent, path: '', noShowingChildren: true }
        return onlyOneChild
      }

      return false
    },
  },
}
</script>

<style lang="scss" scoped>
.app-container {
  .roles-table {
    margin-top: 30px;
  }
  .permission-tree {
    margin-bottom: 30px;
  }
}
</style>
